import React from "react";

interface EnginePrimaryNoteProps {
  engineName: string;
  icon?: string;
}

export default function EnginePrimaryNote({
  engineName,
  icon,
}: EnginePrimaryNoteProps) {
  return (
    <div className="flex items-center gap-2 text-sm text-gray-600 mt-2">
      {icon && (
        <img
          src={icon}
          alt={`${engineName} icon`}
          className="w-4 h-4"
        />
      )}
      <span>{engineName} is currently the primary engine</span>
    </div>
  );
}
